<template>
    <div class="success-screen">

        <div class="success-section">
            <div class="poly-wrap" ref="polyWrap">
                <div ref="poly1"></div>
                <div ref="poly2"></div>
                <div ref="poly3"></div>
                <div ref="poly4"></div>
                <div ref="poly5"></div>
                <div ref="poly6"></div>
                <div ref="poly7"></div>
                <div ref="poly8"></div>
                <div ref="poly9"></div>
                <div ref="poly10"></div>
                <div ref="poly11"></div>
                <div ref="poly12"></div>
                <div ref="poly13"></div>
                <div ref="poly14"></div>
                <div ref="poly15"></div>
            </div>

            <div class="tag-big">
                <span>
                    <i class="icon-big-check"></i>
                </span>
                <p class="text">Odgovori su uspješno predani. Sretno</p>
            </div>
        </div>

    </div>
</template>

<script>
import { TimelineMax, TweenMax, Linear, Power3 } from 'gsap'

export default {
    name: 'successScreen',
    mounted: function () {
        var poly1 = this.$refs.poly1
        var poly2 = this.$refs.poly2
        var poly3 = this.$refs.poly3
        var poly4 = this.$refs.poly4
        var poly5 = this.$refs.poly5
        var poly7 = this.$refs.poly6
        var poly8 = this.$refs.poly7
        var poly9 = this.$refs.poly8
        var poly10 = this.$refs.poly9
        var poly11 = this.$refs.poly10
        var poly12 = this.$refs.poly11
        var poly13 = this.$refs.poly12
        var poly14 = this.$refs.poly13
        var poly15 = this.$refs.poly14

        TweenMax.to(poly1, 2.4, {
            x: 15,
            repeat: -1,
            yoyo: true,
            delay: 0.2,
            ease: Linear.ease
        })

        var timeline = new TimelineMax({
            repeat: -1
        })

        timeline
            // poly7
            .to(poly7, 0.8, {
                rotation: 90,
                transformOrigin: '50%'
            })
            .add('firstSet')

            // poly13
            .to(poly13, 0.35, {
                y: 25,
                ease: Power3.easeOut
            }, 'firstSet -=0.4')

            // poly2
            .to(poly2, 0.2, {
                y: -20,
                ease: Power3.easeOut
            }, 'firstSet +=0.2')
            .to(poly2, 0.2, {
                y: 0,
                ease: Power3.easeIn
            }, 'firstSet +=0.4')
            .to(poly2, 0.2, {
                y: -20,
                ease: Power3.easeOut
            }, 'firstSet +=0.6')
            .to(poly2, 0.2, {
                y: 0,
                ease: Power3.easeIn
            }, 'firstSet +=0.8')

            // poly3
            .to(poly3, 0.8, {
                rotation: 45,
                transformOrigin: '20% 100%',
                ease: Power3.easeInOut
            }, 'firstSet -=0.4')
            .to(poly3, 0.4, {
                rotation: 0,
                transformOrigin: '20% 100%',
                ease: Power3.easeIn
            }, 'firstSet +=1.2')

            // poly5
            .to(poly5, 0.4, {
                scaleY: 0.7,
                transformOrigin: '50% 100%',
                ease: Power3.easeOut
            }, 'firstSet -=0.4')
            .to(poly5, 0.1, {
                scaleY: 1,
                transformOrigin: '50% 100%',
                ease: Power3.easeIn
            }, 'firstSet')

            // poly4
            .to(poly4, 2.4, {
                rotation: 360,
                transformOrigin: '50%',
                ease: Power3.easeOut
            }, 'firstSet +=0.1')

            // poly8
            .to(poly8, 0.4, {
                x: 20,
                ease: Linear.ease
            }, 'firstSet +=0.7')
            .to(poly8, 0.3, {
                x: 0,
                ease: Linear.easeIn
            }, 'firstSet +=1.1')

            // poly9
            .to(poly9, 0.3, {
                x: 30,
                y: 20,
                ease: Power3.easeInOut
            }, 'firstSet +=1.3')
            .to(poly9, 0.3, {
                x: 0,
                y: 0,
                ease: Power3.easeInOut
            }, 'firstSet +=1.6')

            // poly10
            .to(poly10, 1.4, {
                rotationY: 360,
                transformOrigin: '50%',
                ease: Linear.ease
            }, 'firstSet +=0.8')

            // poly11
            .to(poly11, 1, {
                x: '-50%',
                ease: Power3.easeInOut
            }, 'firstSet +=1.3')
            .to(poly11, 0.2, {
                x: '0%',
                ease: Power3.easeIn
            }, 'firstSet +=2.3')

            // poly12
            .to(poly12, 1, {
                rotation: 1080,
                ease: Linear.ease
            }, 'firstSet +=1')

            // poly14
            .to(poly14, 2, {
                rotation: 360,
                ease: Linear.ease
            }, 'firstSet -=0.4')

            .to(poly13, 0.2, {
                y: 0,
                ease: Power3.easeIn
            }, 'firstSet +=1')
            .to(poly7, 0.8, {
                rotation: 0
            }, 'firstSet +=1')

            // poly15
            .to(poly15, 0.5, {
                x: -25,
                ease: Linear.ease
            }, 'firstSet -=0.4')
            .to(poly15, 0.8, {
                y: 20,
                x: 25,
                ease: Linear.ease
            }, 'firstSet +=0.1')
            .to(poly15, 0.8, {
                y: -10,
                x: 30,
                ease: Linear.ease
            }, 'firstSet +=0.9')
            .to(poly15, 0.5, {
                y: 0,
                x: 0,
                ease: Linear.ease
            }, 'firstSet +=1.7')

        var bdy = document.querySelector('body')
        var parent2 = document.querySelector('.success-section')
        var parent2Children = document.querySelectorAll('.success-section > *')
        var parent2FirstChild = document.querySelectorAll('.success-section > *:nth-child(1)')
        var polygon = document.querySelectorAll('.success-section .tag-big > span')
        var coin = document.querySelectorAll('.success-section .tag-big > span > b')

        // set
        TweenMax.set([parent2, bdy], {
            opacity: 0,
            display: 'none'
        })
        TweenMax.set(parent2Children, {
            opacity: 0,
            y: 100,
            display: 'none'
        })
        TweenMax.set(parent2FirstChild, {
            opacity: 0,
            y: 0,
            display: 'none'
        })
        TweenMax.set(polygon, {
            rotationY: 450,
            y: -50
        })
        TweenMax.set(coin, {
            scale: 0.5,
            opacity: 0
        })

        function load () {
            TweenMax.to(bdy, 0.3, {
                opacity: 1,
                display: 'block',
                ease: Power3.easeInOut
            })
            TweenMax.to(parent2, 0.6, {
                opacity: 1,
                display: 'flex',
                ease: Power3.easeInOut
            })
            TweenMax.staggerTo(parent2Children, 1, {
                opacity: 1,
                y: 0,
                delay: 0.3,
                display: 'block',
                ease: Power3.easeOut
            }, 0.2)

            TweenMax.to(polygon, 1.6, {
                rotationY: 0,
                y: 0,
                ease: Power3.easeOut,
                delay: 0.5
            })
            TweenMax.to(coin, 0.8, {
                scale: 1,
                opacity: 1,
                delay: 1,
                ease: Power3.easeInOut
            })
        }
        if (document.readyState === 'complete') {
            load()
        } else {
            document.addEventListener('readystatechange', function () {
                if (document.readyState === 'complete') {
                    load()
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>

$font-mPlus: 'mPlus';

.success-screen {
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 550;
    .success-section {
        position: relative;
        width: 100%;
        min-height: calc(100vh);
        display: flex;
        align-items: center;

        .poly-wrap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(~@/assets/img/sample/success-bg.jpg) 50% 0 no-repeat;
            background-size: cover;

            div {
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: 50%;
                opacity: 0.08;
            }
        }
        .tag {
            width: 100%;
            position: absolute;
            left: 0;
            top: 10px;
            text-align: center;
            padding-top: 120px;

            span {
                position: absolute;
                left: calc(50% - 77.5px);
                top: 0;
                display: block;
                width: 155px;
                height: 163px;
                background: url(~@/assets/img/icons/polygon.png) 50% no-repeat;
                background-size: 155px;
            }
            i {
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-position: 50%;
                background-size: contain;
                background-repeat: no-repeat;
            }
            .name {
                font-size: 22px;
                color: #fff;
                font-weight: 900;
                text-transform: uppercase;
                margin: 0;
            }
        }
        .tag-big {
            perspective: 1000px;
            position: relative;
            width: 100%;
            text-align: center;
            padding-top: 230px;

            > span {
                position: absolute;
                left: calc(50% - 134.5px);
                top: 0;
                display: block;
                width: 269px;
                height: 283px;
                background: url(~@/assets/img/icons/polygon-2.png) 50% no-repeat;
                background-size: 269px;
            }
            > span.type-2 {
                background: url(~@/assets/img/icons/polygon-9.png) 50% no-repeat;
                background-size: 269px;
            }
            b {
                display: block;
                position: absolute;
                top: -25px;
                left: calc(50% - 71.5px);
                width: 143px;
                height: 142px;
                background-position: 50%;
                background-size: contain;
                background-repeat: no-repeat;
            }
            i {
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-position: 50%;
                background-size: contain;
                background-repeat: no-repeat;
            }
            .text {
                font-family: $font-mPlus;
                max-width: 300px;
                font-size: 28px;
                line-height: 33px;
                letter-spacing: -0.2px;
                color: #fff;
                font-weight: 800;
                margin: auto auto 10px auto;
                z-index: 2;
                position: relative;

                span.b {
                    color: #65aaeb;
                }
                span.g {
                    color: #90c744;
                }
                span.r {
                    color: #fd4401;
                }
                span.y {
                    color: #fbc701;
                }
            }
            p {
                max-width: 300px;
                color: #fff;
                letter-spacing: .3px;
                line-height: 22px;
                margin: auto;
            }

            strong {
                display: block;
                position: absolute;
                left: 0;
                top: 80px;
                width: 100%;
                font-family: $font-mPlus;
                font-weight: 800;
                text-align: center;
                letter-spacing: -3.7px;
                color: #fff;
                font-size: 50px;
                line-height: 40px;
            }
            small {
                display: block;
                font-weight: 600;
                font-size: 24px;
                letter-spacing: .5px;
            }
        }
    }

    .poly-wrap {
        overflow: hidden;

        div:nth-child(1) {
            background-image: url(~@/assets/img/polygons/poly-1.png);
            bottom: -8%;
            left: 9%;
            width: 191.4%;
            height: 19.2%;
        }
        div:nth-child(2) {
            background-image: url(~@/assets/img/polygons/poly-2.png);
            bottom: 13%;
            right: 20%;
            width: 25.5%;
            height: 11.8%;
        }
        div:nth-child(3) {
            background-image: url(~@/assets/img/polygons/poly-3.png);
            right: -63%;
            bottom: 20%;
            width: 77.3%;
            height: 16.6%;
        }
        div:nth-child(4) {
            background-image: url(~@/assets/img/polygons/poly-4.png);
            bottom: 17%;
            left: -2%;
            width: 39.4%;
            height: 20.65%;
        }
        div:nth-child(5) {
            background-image: url(~@/assets/img/polygons/poly-5.png);
            bottom: 26%;
            right: 40%;
            width: 9.35%;
            height: 13.2%;
        }
        div:nth-child(6) {
            background-image: url(~@/assets/img/polygons/poly-6.png);
            bottom: 40%;
            right: 10%;
            width: 11.1%;
            height: 6.2%;
        }
        div:nth-child(7) {
            background-image: url(~@/assets/img/polygons/poly-7.png);
            right: -40%;
            top: 8%;
            width: 82%;
            height: 37.9%;
        }
        div:nth-child(8) {
            background-image: url(~@/assets/img/polygons/poly-8.png);
            left: 27%;
            top: 4%;
            width: 45%;
            height: 5.9%;
        }
        div:nth-child(9) {
            background-image: url(~@/assets/img/polygons/poly-9.png);
            top: 22%;
            left: 27%;
            width: 21%;
            height: 8.5%;
        }
        div:nth-child(10) {
            background-image: url(~@/assets/img/polygons/poly-10.png);
            left: -16%;
            top: 4%;
            width: 52.8%;
            height: 24.7%;
        }
        div:nth-child(11) {
            background-image: url(~@/assets/img/polygons/poly-11.png);
            top: 34%;
            left: 0%;
            width: 40.3%;
            height: 17.5%;
        }
        div:nth-child(12) {
            background-image: url(~@/assets/img/polygons/poly-12.png);
            left: 47%;
            top: 37%;
            width: 10.7%;
            height: 4.95%;
        }
        div:nth-child(13) {
            background-image: url(~@/assets/img/polygons/poly-13.png);
            top: 45%;
            right: 24%;
            width: 24.2%;
            height: 11.25%;
        }
        div:nth-child(14) {
            background-image: url(~@/assets/img/polygons/poly-14.png);
            top: 54%;
            left: 25%;
            width: 11.8%;
            height: 5.5%;
        }
        div:nth-child(15) {
            background-image: url(~@/assets/img/polygons/poly-15.png);
            top: 55%;
            left: 6%;
            width: 5.4%;
            height: 2.5%;
        }
    }
}

.shape {
    width: 280px;
    height: 280px;
    background: url(~@/assets/img/icons/polygon-2.png) 50% no-repeat;
    background-size: contain;
    margin: auto;
}

</style>
